import axios from "api/axios";

export const getUserRole = () => {
  return axios.get("/user" );
};